import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import sortUpImg from '../../../../assets/images/table/sort-up.svg';
import sortDownImg from '../../../../assets/images/table/sort-down.svg';
import sortUpActiveImg from '../../../../assets/images/table/sort-up-active.svg';
import sortDownActiveImg from '../../../../assets/images/table/sort-down-active.svg';

export const HeaderCell = ({headers, field, sort = {}, onClick = () => {}}) => {
  const filtered = sort.field === field;
  let nextField = field;
  let nextDirection = filtered ? (sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';

  if (sort.direction === 'desc' && filtered) {
    nextField = undefined;
    nextDirection = undefined;
  }

  const sortEl = sort.direction === 'asc' ?
    <SortArrowStyled className="sort-up"/> :
    <SortArrowStyled className="sort-down"/>;

  const hint = sort.field ? 'Click to sort' : '';

  return (
    <th onClick={() => onClick(nextField, nextDirection)} className={`${headers[field].className || ''}${filtered ? ' filtered' : ''}`} title={hint}>
      {headers[field].title} {filtered && sortEl}{!filtered && headers[field].sortPlaceholder}
      {
        headers[field].isAllCheckbox &&
        <input
          type="checkbox"
          checked={headers[field].componentArgs.isAllChecked()}
          onClick={event => event.stopPropagation()}
          onChange={headers[field].componentArgs.onChangeAll}
        />
      }
    </th>
  );
};

const SortArrowStyled = styled.span`
  display: inline-block;
  height: 10px;
  width: 10px;
  &.sort-down {
    background-image: url(${sortUpImg}), url(${sortDownActiveImg});
  }
  &.sort-up {
    background-image: url(${sortUpActiveImg}), url(${sortDownImg});
  }
  background-position: right top, right bottom;
  background-repeat: no-repeat, no-repeat;
`;

HeaderCell.propTypes = {
  headers: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  sort: PropTypes.object,
  onClick: PropTypes.func
};
